import { useState } from 'react'
import { FaChevronDown } from 'react-icons/fa'

export default function Accordion({ title, children }) {
  const [isOpen, setisOpen] = useState(false)
  function handleOnTaggle() {
    setisOpen(!isOpen)
  }
  return (
    <div className="border-2 border-muted-300">
      <button
        onClick={handleOnTaggle}
        className={`flex w-full items-center justify-between ${isOpen && 'border-b-2'} border-muted-300 bg-muted-100 p-2 px-4`}
      >
        <span className="text-lg font-semibold">{title}</span>
        <FaChevronDown className={`transition-transform duration-300 ${isOpen ? 'rotate-0' : '-rotate-90'}`} />
      </button>
      {isOpen && children}
    </div>
  )
}
